// src/components/common/audio-player/ui/AudioControls.tsx

"use client";
import React from "react";
import { Play, Pause } from "lucide-react";
import AudioSpeed from "./AudioSpeed";

import "./AudioControls.css";

type Props = {
  playing: boolean;
  rate: number;
  onToggle: () => void;
  onSlower: () => void;
  onFaster: () => void;
};

const AudioControls: React.FC<Props> = ({
  playing,
  rate,
  onToggle,
  onSlower,
  onFaster,
}) => {
  return (
    <div className="tl-actions">
      <button className="tl-btn main" onClick={onToggle} aria-label={playing ? "Pause" : "Play"}>
        {playing ? <Pause size={32} strokeWidth={1} /> : <Play size={32} strokeWidth={1} />}
      </button>

      <AudioSpeed rate={rate} onSlower={onSlower} onFaster={onFaster} />
    </div>
  );
};

export default AudioControls;
